module.exports = __webpack_public_path__ + "img/pin-star-500.4de06fec.png";